import { render } from "./Team.vue?vue&type=template&id=4fbf6222&bindings={}"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"
script.render = render

export default script